import PropTypes from 'prop-types'
import React from 'react'
import cc from 'classcat'

import Icon from './Icon'
import styles from './Button.css'

function Button(props) {
  const {
    theme,
    tagname,
    children,
    onClick,
    icon,
    disabled,
    loading,
    fullWidth,
    halfWidth,
    inverted,
    fileUpload,
    className,
  } = props

  const classNames = cc([
    styles.btn,
    className,
    {
      // LocalStyles       Prop
      [styles.fullWidth]: fullWidth,
      [styles.inverted]: inverted,
      [styles.fileUpload]: fileUpload,
      [styles.halfWidth]: halfWidth,
      [styles[theme] || '']: true,
    },
  ])

  return React.createElement(
    // `tagname` prop is added to resolve a bug exposed within FireFox.
    //  A <button /> that wraps an <input type="file" />
    //  renders the input not clickable.
    //  Allowing the tag to be a <div> resolves the issue.
    //  However ... transpiling "<tagname>" creates html tags
    //  called <tagname>.
    //  So - using pure JS for the Button wrapper component.
    tagname,
    {
      disabled,
      className: classNames,
      onClick: e => {
        if (!disabled && !loading) {
          onClick(e)
        }
      },
      'data-id': props['data-id'],
      'data-test-id': props['data-test-id'],
    },
    icon && <Icon name={icon} spin={loading} />,
    children
  )
}

Button.defaultProps = {
  theme: 'bibme',
  tagname: 'button',
  disabled: false,
  loading: false,
  onClick: () => {},
  'data-id': '',
  'data-test-id': '',
  icon: undefined,
  inverted: false,
  halfWidth: false,
  fullWidth: false,
  fileUpload: false,
  className: '',
}
Button.propTypes = {
  theme: PropTypes.string,
  tagname: PropTypes.oneOf(['button', 'div']),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  icon: PropTypes.string,
  'data-id': PropTypes.string,
  'data-test-id': PropTypes.string,
  inverted: PropTypes.bool,
  halfWidth: PropTypes.bool,
  fileUpload: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
}

export default Button
